/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://i7yzereivnbebd64olvmruquqm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-jchgtmfzlra3xbrz2bfbp6kf7u",
    "aws_cognito_identity_pool_id": "us-east-1:b22b9f39-e468-4864-b325-94e5585aca7b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_9ofHhsDwG",
    "aws_user_pools_web_client_id": "6tk0q95h61c7n848lcpbe815kb",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
